import type { UseQueryOptions } from '@tanstack/react-query'
import queryClient from './queryClient'

export const IS_WHATS_NEW_MODAL_SHOW_QUERY_OPTIONS: UseQueryOptions<boolean> = {
	queryKey: ['IS_WHATS_NEW_MODAL_SHOW'],
	queryFn: () => false,
	initialData: false,
	enabled: false,
	retry: false,
}

export function showWhatsNewModal() {
	return queryClient.setQueryData(IS_WHATS_NEW_MODAL_SHOW_QUERY_OPTIONS.queryKey, true)
}

export function hideWhatsNewModal() {
	return queryClient.setQueryData(IS_WHATS_NEW_MODAL_SHOW_QUERY_OPTIONS.queryKey, false)
}
